import { $detail, $user, $view } from 'signals/global.signals';
import { getPublicRoomById } from 'api/rooms.api';
import { getOrgTeams } from 'api/teams.api';
import { getOrgDealflow } from 'api/dealflow.api';
import displayError from 'utils/displayError';

function userHasAccessToDeal() {
  const submittedEmail = window.localStorage.getItem('submittedEmail');

  return !!$user.value.id || !!submittedEmail;
}

export const fetchAndSetPublicDealData = async ({ id }) => {
  try {
    $detail.update({
      isLoading: true,
    });

    const fetchPromises = [
      getPublicRoomById(id),
      $user.value.id ? getOrgDealflow() : Promise.resolve({ data: null }),
      $user.value.id ? getOrgTeams($user.value.organization.id) : Promise.resolve({ data: [] }),
    ];

    const [room, { data: dealflowData }, { data: teams }] = await Promise.all(fetchPromises);

    const dealflow = dealflowData?.find((dealflowRecord) => dealflowRecord.dealId === room.dealId);

    if (!room) {
      window.location.href = '/';
    }

    const teamOptions = teams?.map((team) => ({
      label: team.name,
      value: team.id,
    }));

    $view.update({
      teamOptions: teamOptions || [],
    });

    $detail.update({
      ...room,
      id: Number(id),
      dealRating: dealflow?.rating,
      dealExistsInPipeline: !!dealflow,
      userHasAccessToDeal: userHasAccessToDeal(room.views),
    });
  } catch (error) {
    displayError({
      message: 'Failed to load deal room data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $detail.update({
      isLoading: false,
    });
  }
};
